module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Rise of the Tang Dynasty")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../style/9781473887794.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-head"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Technical Issues")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("D")]), _vm._v("ealing with Chinese history, one is faced with numerous technical problems. Firstly, the transliteration of Chinese words into European tongues is not only controversial, but often it represents a political orientation. The older Wade-Giles method was used by the Kuomintang of Chiang Kai-shek (whose name is his personal transliteration) and often stands in opposition to the Zhongguo Gongchandang of Mao Zedong. The Chairman, Mao, instituted an official transliteration format: Pinyin. There are arguments over which method is better, but often the result is more of a political decision than anything else. Those who oppose Red China use Wade-Giles; those who support Red China use Pinyin. Over the years, however, tensions between the People’s Republic of China and the Atlantic states have lessened. The scholars in the Peoples’ Republic have long been producing high-quality historical works. Clearly, the future of Chinese historical investigation is in their hands. So I use Pinyin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Secondly, translations of Chinese texts leave a lot to be desired. Many translators use exotic English words to translate Chinese characters; for instance, ‘erudite scholar’, which could just as accurately be ‘accomplished scholar’. I try to use simple English to translate Chinese because, in my experience, Chinese speakers want to be direct and clear. Titles are another issue. The Five Titles of Nobility - "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gong")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hou")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bo")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("zi")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nan")]), _vm._v(" - are used from at least the late Shang throughout Chinese history until 1911. Tzu Hsi and her court convinced the British to translate them into English feudal titles: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gong")]), _vm._v(" becomes duke; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hou")]), _vm._v(" becomes marquis; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bo")]), _vm._v(" becomes earl; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("zi")]), _vm._v(" becomes viscount; and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nan")]), _vm._v(" becomes baron. This may have been a good idea for diplomatic usage, but it is utterly ridiculous for historical usage. Chinese history has many ins and outs, but there is absolutely nothing like medieval English feudalism in Chinese history. To call the member of the early Zhou Dynasty the Duke of Zhou makes no sense. I translate "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gong")]), _vm._v(" as Lord and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hou")]), _vm._v(" as Master.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As translation aids, I have found the following most useful: Rick Harbaugh, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chinese Characters a Genealogy and Dictionary")]), _vm._v(" (Yale, 2009); Quanyu Huang et al, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("McGraw-Hill’s Chinese Dictionary and Guide")]), _vm._v(" (New York, 2010); and Paul Kroll, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Student’s Dictionary of Classical and Medieval Chinese")]), _vm._v(" (Leiden, 2015)."), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4161f932","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 72
// module chunks = 0